import { Box, Divider, Paper, PaperProps, Stack, SxProps, Theme, Typography } from "@mui/material";
import React from "react";
import IconComponent from "./IconComponent";

type PanelProps = PaperProps & {
  headerLabel?: string;
  headerIconName?: string;
  headerActions?: React.ReactNode;
  headerSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
  compact?: boolean;
  usePaper?: boolean;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

const Panel = React.forwardRef<HTMLDivElement, PanelProps>(function Panel(
  { headerLabel, headerIconName, headerActions, headerSx, contentSx, compact, usePaper = true, children, sx, ...rest },
  ref
) {
  const content = (
    <>
      {headerLabel && (
        <>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5, ...headerSx }}>
            {headerIconName && <IconComponent iconName={headerIconName} />}
            <Typography variant={compact ? "body1" : "h6"} gutterBottom sx={{ flex: 1 }}>
              {headerLabel}
            </Typography>
            {headerActions && <Box>{headerActions}</Box>}
          </Stack>
          {!compact && <Divider flexItem sx={{ mb: 2 }} />}
        </>
      )}
      <Box sx={{ flex: 1, minHeight: 0, ...contentSx }}>{children}</Box>
    </>
  );

  const surfaceSx: SxProps<Theme> = [
    { p: 2, borderRadius: 2, display: "flex", flexDirection: "column" },
    ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
  ];

  if (!usePaper) {
    return (
      <Box ref={ref} sx={surfaceSx} {...rest}>
        {content}
      </Box>
    );
  }

  return (
    <Paper ref={ref} sx={surfaceSx} elevation={3} {...rest}>
      {content}
    </Paper>
  );
});

export default Panel;
